<template>
  <div>
    <h4>景区管理</h4>
    <router-view></router-view>
  </div>
</template>
